import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../assets/styles/components/loading-layer.scss';
import '../../assets/styles/components/app-loader.scss';
import LoadingSpinner from './LoadingSpinner';
import { LOADING_TYPE } from '../../constants/app';
import { Icons } from '../../configurations';
import ContentLoader from 'react-content-loader'

class LoadingLayer extends Component {
  render() {
    const { language, loadingMessage, load, type, style = {} } = this.props;
    return (
      <div
        className="customer-loading-overlay"
        style={Object.assign({}, { display: load ? 'block' : 'none' }, style)}
      >
        {
          type === LOADING_TYPE.TEXT && <div className="loading-text">{language[loadingMessage]}</div>
        }
        {
          type === LOADING_TYPE.SMALL_IMG && <div className="loading-img"><Icons.Loading /></div>
        }
        {
          type === LOADING_TYPE.BIG_IMG && <div className="loading-img"><LoadingSpinner /></div>
        }
        { 
          type === LOADING_TYPE.SKELETON && <HeadBodyGrid {...this.props} /> 
        }

      </div>
    );
  }
}


const HeadBodyGrid = (props) => {
  const {height ,width,speed,children,theme, fixedTheme } = props

  const currentTheme = fixedTheme || theme

  return(
    // 1d232e   181d26
    //          1a1d23
    //          1c2026
    <ContentLoader height={ height ? height : "200"} width={ width ? width : "200"} speed={speed ? speed : 2 }   backgroundColor= { currentTheme == 'light' ? "#e3eaf2" : '#1d232e'}
    foregroundColor={currentTheme == 'light' ? "#9c9ea1" :"#1c2026"}>
       { !children && <><rect x="25" y="25" rx="5" ry="5" width="150" height="150" /></>  }
       { children }
  </ContentLoader>)
}
  

LoadingLayer.defaultProps = {
  loadingMessage: 'common_msg_loading',
  load: false,
  type: LOADING_TYPE.TEXT
}

export default connect(
  state => ({
    language: state.app.language,
    theme:state.app.theme
  })
)(LoadingLayer)